import { keyframes } from '@emotion/react';

const auroraChromeShift = keyframes`
  0%, 100% { background-position: 0% 50%, 100% 50%, 50% 50%; }
  50%      { background-position: 18% 50%, 82% 50%, 62% 50%; }
`;

export function auroraTopbarSx(theme) {
  const isLight = theme.palette.mode === 'light';
  return {
    background: isLight
      ? `radial-gradient(ellipse 70% 180% at 0% 50%, rgba(247,179,43,0.38) 0%, rgba(247,179,43,0) 60%),
         radial-gradient(ellipse 55% 180% at 100% 50%, rgba(255,150,110,0.42) 0%, rgba(255,150,110,0) 60%),
         radial-gradient(ellipse 40% 180% at 50% 50%, rgba(125,164,217,0.22) 0%, rgba(125,164,217,0) 70%),
         rgba(255,255,255,0.62)`
      : `radial-gradient(ellipse 70% 180% at 0% 50%, rgba(242,101,34,0.32) 0%, rgba(242,101,34,0) 60%),
         radial-gradient(ellipse 55% 180% at 100% 50%, rgba(255,150,110,0.22) 0%, rgba(255,150,110,0) 60%),
         radial-gradient(ellipse 40% 180% at 50% 50%, rgba(27,54,93,0.55) 0%, rgba(27,54,93,0) 70%),
         rgba(18,26,43,0.55)`,
    backgroundSize: '220% 220%, 220% 220%, 220% 220%, auto',
    animation: `${auroraChromeShift} 28s ease-in-out infinite`,
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
  };
}
